import React from 'react';
import { cnBem } from '@carnica/utils';
import styles from "./styles.pcss";
import { Skeleton } from "../../../common/Skeleton";
var cnCardList = cnBem('card-list', styles);
export var CardListSkeleton = function CardListSkeleton() {
  return /*#__PURE__*/React.createElement("ul", {
    className: cnCardList(null, ['container']),
    "data-t-id": "components-CardListSkeleton"
  }, Array.from({
    length: 6
  }, function () {
    return /*#__PURE__*/React.createElement("li", {
      className: cnCardList(null, ['main'])
    }, /*#__PURE__*/React.createElement(Skeleton, {
      className: cnCardList(null, ['icon'])
    }), /*#__PURE__*/React.createElement(Skeleton, {
      className: cnCardList(null, ['title'])
    }));
  }));
};